<template lang="pug">
  div
    general-table(
      :loading="loading"
      :items="items"
      @select="onSelect")
    v-dialog(
      :max-width="1160"
      :value="selectedId !== null"
      @input="selectedId = null")
      mixer-uploads-detail(
        :selected="selectedItem"
        @close="selectedId = null")
    ui-pagination(
      v-if="showPagination"
      v-model="page"
      :page-count="pageCount"
      @page-change="pageChangeHandler")
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import { getDateForDatePicker } from '@/util'
import UiPagination from '@/components/ui/ui-pagination/UiPagination.vue'
import GeneralTable from '../general-table/GeneralTable'
import MixerUploadsDetail from './MixerUploadsDetail'
import paginationMixin from '@/mixins/pagination.mixin'
export default {
  name: 'MixerUploadsList',
  components: {
    MixerUploadsDetail,
    GeneralTable,
    UiPagination
  },

  data: () => ({
    selectedId: null,
    loaded: false,
    watchFilters: true
  }),
  mixins: [paginationMixin],
  computed: {
    ...mapGetters('reports', [
      'upload',
      'filters',
      'totalCount'
    ]),
    timezone () {
      return this.$store.getters['account/timezone']
    },
    selectedItem () {
      return this.items.find(item => item.id === this.selectedId)
    },
    allowView () {
      return this.hasPermission('load', 'view')
    }
  },

  async mounted () {
    const farmId = this.$route.params.farm_id
    sessionStorage.removeItem(`reports_${farmId}_uploads`)
    this.watchFilters = false

    const hasDateFilters = this.filters.planned_on_before && this.filters.planned_on_after
    /* eslint-disable camelcase */
    const today = getDateForDatePicker(this.timezone)
    const planned_on_before = hasDateFilters ? this.filters.planned_on_before : today
    const planned_on_after = hasDateFilters ? this.filters.planned_on_after : today

    const baseFilters = {
      planned_on_before,
      planned_on_after,
      farm: farmId
    }
    /* eslint-enable camelcase */
    const fullFilters = hasDateFilters
      ? {
        ...baseFilters,
        group: [],
        animal_type: [],
        ration: [],
        loading: [],
        status: [],
        loaded_time_max: null,
        loaded_time_min: null
      }
      : baseFilters

    this.$store.dispatch('reports/applyFilters', fullFilters)

    await this.setupPagination(
      api.reports.upload.list,
      {
        ...baseFilters,
        page: this.page > 1 ? this.page : 1
      },
      `reports_${farmId}_uploads`
    )
    this.$store.dispatch('reports/applyTotal', this.pageCount)
    this.watchFilters = true
  },


  methods: {
    onSelect (item) {
      this.selectedId = item.id
    }
  },
  watch: {
    filters: {
      async handler () {
        const farmId = this.$route.params.farm_id
        if (this.watchFilters) {
          await this.$router.push({
            query: {
              ...this.$route.query,
              page: 1
            }
          })
          if (!this.filters.planned_on_before && !this.filters.planned_on_after) {
            const today = getDateForDatePicker(this.timezone)
            this.$store.dispatch('reports/applyFilters', {
              planned_on_before: today,
              planned_on_after: today,
              farm: farmId
            })
          }
          await this.setupPagination(
            api.reports.upload.list,
            {
              farm: farmId,
              ...this.filters,
              page: 1
            },
            `reports_${farmId}_uploads`
          )
          this.$store.dispatch('reports/applyTotal', this.pageCount)
        }
      },
      deep: true
    }
  }
}
</script>
